var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _circle7, _path6, _path7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 277,
    viewBox: "0 0 274 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.851,
    cy: 50.6518,
    r: 33.2399,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.6148,
    cy: 190.734,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.048,
    cy: 255.631,
    r: 19.7857,
    fill: "#FFD445"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5232,
    cy: 228.723,
    r: 7.12284,
    fill: "#FFD445"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.666,
    cy: 143.249,
    r: 92.597,
    fill: "#FFD445"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.214,
    cy: 127.42,
    r: 7.12284,
    fill: "#FFD445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.86 110.141C56.0522 110.141 61.0719 105.121 61.0719 98.9289C61.0719 92.7367 56.0522 87.717 49.86 87.717C43.6679 87.717 38.6481 92.7367 38.6481 98.9289C38.6481 105.121 43.6679 110.141 49.86 110.141ZM49.86 112.383C57.2906 112.383 63.3143 106.359 63.3143 98.9289C63.3143 91.4983 57.2906 85.4746 49.86 85.4746C42.4294 85.4746 36.4058 91.4983 36.4058 98.9289C36.4058 106.359 42.4294 112.383 49.86 112.383Z",
    fill: "#FFD445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.42 274.758C133.612 274.758 138.632 269.738 138.632 263.546C138.632 257.354 133.612 252.334 127.42 252.334C121.228 252.334 116.208 257.354 116.208 263.546C116.208 269.738 121.228 274.758 127.42 274.758ZM127.42 277C134.851 277 140.874 270.976 140.874 263.546C140.874 256.115 134.851 250.092 127.42 250.092C119.989 250.092 113.966 256.115 113.966 263.546C113.966 270.976 119.989 277 127.42 277Z",
    fill: "#FFD445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4992 25.8529C23.5078 31.6215 20.0845 44.3974 25.8531 54.3888C31.6216 64.3802 44.3976 67.8036 54.389 62.035C64.3804 56.2665 67.8037 43.4905 62.0352 33.4991C56.2666 23.5077 43.4906 20.0844 33.4992 25.8529ZM27.8595 16.0845C12.4731 24.9678 7.20137 44.6423 16.0847 60.0286C24.968 75.415 44.6424 80.6867 60.0288 71.8034C75.4151 62.9201 80.6868 43.2457 71.8035 27.8593C62.9202 12.473 43.2458 7.20124 27.8595 16.0845Z",
    fill: "#FFD445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0011 92.2641C15.7599 93.558 14.9921 96.4237 16.286 98.6649C17.5799 100.906 20.4457 101.674 22.6868 100.38C24.9279 99.086 25.6958 96.2203 24.4019 93.9792C23.108 91.738 20.2422 90.9701 18.0011 92.2641ZM17.5325 91.4525C14.8431 93.0052 13.9217 96.4441 15.4744 99.1334C17.0271 101.823 20.466 102.744 23.1554 101.192C25.8447 99.6388 26.7662 96.2 25.2135 93.5106C23.6608 90.8212 20.2219 89.8998 17.5325 91.4525Z",
    fill: "#FFD445"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.463 236.304C139.222 237.598 138.454 240.464 139.748 242.705C141.042 244.946 143.908 245.714 146.149 244.42C148.39 243.126 149.158 240.26 147.864 238.019C146.57 235.778 143.705 235.01 141.463 236.304ZM140.995 235.492C138.306 237.045 137.384 240.484 138.937 243.173C140.49 245.863 143.928 246.784 146.618 245.231C149.307 243.679 150.229 240.24 148.676 237.55C147.123 234.861 143.684 233.94 140.995 235.492Z",
    fill: "#FFD445"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.874,
    cy: 144.04,
    r: 107.634,
    stroke: "#363853",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 211C178.228 211 208 181.228 208 144.5C208 107.772 178.228 78 141.5 78C104.772 78 75 107.772 75 144.5C75 181.228 104.772 211 141.5 211Z",
    fill: "#363853",
    stroke: "#CFD5DC",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.062 195.714C170.036 195.714 192.714 173.037 192.714 145.063C192.714 117.089 170.036 94.4116 142.062 94.4116C114.089 94.4116 91.4111 117.089 91.4111 145.063C91.4111 173.037 114.089 195.714 142.062 195.714Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_5349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.062 140.96L156.427 126.595L160.53 130.699L146.166 145.063L160.53 159.428L156.427 163.531L142.062 149.166L127.698 163.531L123.595 159.428L137.959 145.063L123.595 130.699L127.698 126.595L142.062 140.96Z",
    fill: "#363853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_5349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.6456,
    height: 69.6456,
    fill: "white",
    transform: "translate(107.24 110.24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedProcess);
export default __webpack_public_path__ + "static/media/RejectedProcess.02cd84e52d07be3340b779bf8e0b3ea2.svg";
export { ForwardRef as ReactComponent };